import { createSafeContext } from '@/util';

import type { VToastContextValue } from './type';

export const VToastContext = createSafeContext<VToastContextValue>(
  null,
  'VToastContext',
);
